import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { getParamMasterList } from '../../../layout/action';
import { getAuthTokenFromLS, getCompanyid } from '../../../utils/common';
import { BASE_URL } from '../../../utils/constant';
import { endpoints } from '../../../utils/endpoints';
import { getAllActivePlans } from '../action';
import { updateGlobalLoader } from '../../../components/backdrop/backdropSlice';
import GlobalLoader from '../../../components/backdrop';
const SubscriptionsCompany = () => {
    const navigate = useNavigate();
    const { id } = useParams()
    const dispatch = useDispatch();
    
    useEffect(() => {
        updateGlobalLoader(true);
        dispatch(getParamMasterList());
        dispatch(getAllActivePlans());
        updateGlobalLoader(false);
    }, [dispatch]);


    useEffect(() => {
        updateGlobalLoader(true);
        const fetchData = async () => {
            try {
                const response = await fetch(BASE_URL + endpoints.getAllActivePlans + "/" + getCompanyid(), {
                    headers: {
                        "Authorization": getAuthTokenFromLS()
                    }
                });
                const data = await response.json();
                const activePlanCount1 = data.result.plan;
                const customPlan = data.result.currentPlan;
                const count = activePlanCount1?.filter((v) => v.isActive == 1);
                
                if (id === undefined || !id) {
                    if (count.length === 0 && customPlan?.type !== 'Custom') {
                        navigate("/subscription/active/details/" + getCompanyid())
                    } else {
                        navigate("/subscription/active")

                    }
                }
                 // Do something with the data
            } catch (error) {
                    console.error('Error fetching data:', error);
            }
        };
        updateGlobalLoader(false);
        //
        fetchData();
    }, []);

    return       <GlobalLoader />;

}

export default SubscriptionsCompany